import React from "react";
import { Check } from "lucide-react";
import { TELEMATICS as T } from "../../data/telematics";
import { Seo, faqLd } from "../../components/Seo";
import { CtaLink, SectionHeader, DarkCTA, FaqList, Reveal } from "../../components/Shared";
import { ConnectedVehicleVisual } from "../../components/telematics/PlatformVisuals";
import { ProblemSection, CapabilitiesSection, PlatformSection, AlertsSection, ReportsSection, IndustriesSection, ResultsSection } from "../../components/telematics/TelematicsSections";

const Hero = () => (
  <section className="pt-12 pb-14 md:pt-16 md:pb-20 overflow-hidden" data-testid="telematics-hero">
    <div className="container-x grid lg:grid-cols-[1.05fr_1fr] gap-10 lg:gap-12 items-center">
      <div>
        <span className="eyebrow-pill fade-up">{T.hero.eyebrow}</span>
        <h1 className="h-display h-display-hero mt-5 fade-up delay-1">{T.hero.title}</h1>
        <p className="mt-5 max-w-xl text-base md:text-lg text-[var(--fr-ink-2)] leading-relaxed fade-up delay-2">{T.hero.subtitle}</p>
        <div className="mt-7 flex flex-wrap gap-3 fade-up delay-3">
          <CtaLink cta={T.hero.primary} className="btn btn-primary btn-lg" data-testid="hero-primary-cta" />
          <CtaLink cta={T.hero.secondary} className="btn btn-outline btn-lg" data-testid="hero-secondary-cta" />
        </div>
        <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-1.5 text-sm text-[var(--fr-muted)] fade-up delay-3" data-testid="hero-trust">
          {T.hero.trust.map((t) => (
            <li key={t} className="inline-flex items-center gap-1.5">
              <Check size={14} className="text-[var(--fr-primary)]" strokeWidth={2.5} /> {t}
            </li>
          ))}
        </ul>
      </div>
      <div className="relative fade-up delay-2 lg:max-w-[560px] lg:ml-auto w-full" data-testid="hero-visual">
        <div className="card p-3 shadow-[0_30px_60px_-30px_rgba(14,14,16,0.25)]">
          <div className="img-tile aspect-[6/5] bg-white">
            <ConnectedVehicleVisual className="w-full h-full" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default function FleetTelematics() {
  return (
    <>
      <Seo title={T.seo.title} description={T.seo.description} jsonLd={faqLd(T.faq)} />
      <Hero />
      <ProblemSection data={T.problem} />
      <CapabilitiesSection data={T.capabilities} />
      <PlatformSection data={T.platform} />
      <AlertsSection data={T.alerts} />
      <ReportsSection data={T.reports} />
      <IndustriesSection data={T.industries} />
      <ResultsSection data={T.results} />
      <section className="section bg-[var(--fr-bg-alt)]" data-testid="telematics-faq">
        <div className="container-x grid lg:grid-cols-[1fr_1.4fr] gap-12">
          <SectionHeader eyebrow="FAQ" title="Questions fleet managers ask us." />
          <Reveal delay={100}>
            <FaqList items={T.faq} testid="telematics-faq-list" />
          </Reveal>
        </div>
      </section>
      <div className="pt-16 md:pt-24">
        <DarkCTA title={T.cta.title} text={T.cta.text} cta={T.cta.cta} secondary={T.cta.secondary} />
      </div>
    </>
  );
}
